import { render, staticRenderFns } from "./VeganIcon.vue?vue&type=template&id=05d2a896&scoped=true&"
import script from "./VeganIcon.vue?vue&type=script&lang=js&"
export * from "./VeganIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2a896",
  null
  
)

export default component.exports